import React from 'react';
import { Copy, Check } from 'lucide-react';

interface BadgeFooterProps {
  cleanUibn: string;
  copied: boolean;
  onCopy: () => void;
  onClose: () => void;
}

export const BadgeFooter: React.FC<BadgeFooterProps> = ({
  cleanUibn,
  copied,
  onCopy,
  onClose,
}) => {
  return (
    <div className="p-4 border-t border-slate-200 bg-white flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-2.5">
      <div className="text-xs text-slate-500 flex items-center gap-1">
        <span>Target Tautan:</span>
        <code className="text-indigo-600 font-mono text-[11px]">{cleanUibn}</code>
      </div>

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onCopy}
          className="flex-1 sm:flex-none px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs font-semibold flex items-center justify-center gap-1.5 transition shadow-xs cursor-pointer"
        >
          {copied ? (
            <>
              <Check className="w-4 h-4 text-emerald-300" />
              <span>Kode Berhasil Disalin</span>
            </>
          ) : (
            <>
              <Copy className="w-4 h-4" />
              <span>Salin Kode Sematan</span>
            </>
          )}
        </button>
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl text-xs font-semibold transition cursor-pointer"
        >
          Tutup
        </button>
      </div>
    </div>
  );
};
